import './LoadingPage.less';

export default function LoadingPage(){
  return (
    <div id="loadingPage">
      <div className="container">
        <div className="spinner">
          <div className="rect1"></div>
          <div className="rect2"></div>
          <div className="rect3"></div>
          <div className="rect4"></div>
          <div className="rect5"></div>
        </div>
        {/* <div className="loading-text">加载中</div> */}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/frame/loading-page/LoadingPage.jsx